import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* Общие стили полосы прокрутки */
  &::-webkit-scrollbar {
    width: 6px; /* Ширина полосы прокрутки */
    height: 6px; /* Высота полосы прокрутки */
  }

  /* Стили фона полосы прокрутки */
  &::-webkit-scrollbar-track {
    background: #110C11; /* Цвет фона полосы прокрутки */
  }

  /* Стили ползунка прокрутки */
  &::-webkit-scrollbar-thumb {
    background: var(--color-primary); /* Цвет ползунка прокрутки */
    border-radius: 6px; /* Радиус скругления ползунка */
  }

  /* Изменение стилей при наведении на ползунок */
  &::-webkit-scrollbar-thumb:hover {
    background: var(--color-primary); /* Новый цвет ползунка при наведении */
  }

  .react-horizontal-scrolling-menu--wrapper {
    width: 100%;
  }
  
  .moon-image {
    position: absolute !important;
    top: 0;
    right: 0;
    width: 50%;
    opacity: .8;
    z-index: -1;

    @media (max-width: 1200px) {
      width: 100%;
    }
  }
  
  .teams-scroll-container {
    display: flex;
    align-items: stretch;
  }
`;

export default GlobalStyle;
